// Evita loop: marca sessão para não redirecionar após limpar filtro
(function () {
  const PARAM = 'filter.v.t.shopify.target-gender';
  const params = new URLSearchParams(window.location.search);
  const cleared = sessionStorage.getItem('gender_filter_cleared');

  if (!params.has(PARAM) && !cleared) {
    // Descobre o GID correto do checkbox Masculino
    const checkboxes = document.querySelectorAll(
      `input[type="checkbox"][name="${PARAM}"]`
    );
    for (const cb of checkboxes) {
      const label = cb.closest('li')?.querySelector('.facet-checkbox__label, label, span');
      if (label && label.textContent.trim().toLowerCase() === 'masculino') {
        const target = new URL(window.location.href);
        target.searchParams.set(PARAM, cb.value); // usa o GID real
        window.location.replace(target.toString());
        return;
      }
    }
  }

  sessionStorage.removeItem('gender_filter_cleared');
})();

document.addEventListener('DOMContentLoaded', function () {
  const PARAM = 'filter.v.t.shopify.target-gender';
  const genderButtons = document.querySelectorAll('.gender-btn:not(.gender-btn--clear)');
  const clearBtn = document.querySelector('.gender-btn--clear');

  function findCheckbox(gender) {
    const checkboxes = document.querySelectorAll(
      `input[type="checkbox"][name="${PARAM}"]`
    );
    for (const cb of checkboxes) {
      const label = cb.closest('li')?.querySelector('.facet-checkbox__label, label, span');
      if (label && label.textContent.trim().toLowerCase() === gender.toLowerCase()) {
        return cb;
      }
    }
    return null;
  }

  function updateActiveState() {
    genderButtons.forEach(btn => {
      const url = new URL(btn.href);
      const value = url.searchParams.get(PARAM);
      const checkbox = findCheckbox(value);
      btn.classList.toggle('active', checkbox && checkbox.checked);
    });
  }

  genderButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const url = new URL(this.href);
      const value = url.searchParams.get(PARAM);
      const checkbox = findCheckbox(value);
      if (checkbox) {
        checkbox.click();
        updateActiveState();
      }
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      // Marca que o usuário limpou — evita o loop de redirect
      sessionStorage.setItem('gender_filter_cleared', '1');
      genderButtons.forEach(btn => {
        const url = new URL(btn.href);
        const value = url.searchParams.get(PARAM);
        const checkbox = findCheckbox(value);
        if (checkbox && checkbox.checked) checkbox.click();
      });
      updateActiveState();
    });
  }

  updateActiveState();
});
